export default __webpack_public_path__ + "static/media/targetArrow.6a23d201.svg";